/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InfraVulnerabilitiesTrendListRequest {
    getFixupPrototypeFunction() { return InfraVulnerabilitiesTrendListRequest.fixupPrototype; }

    static newInstance(model: Partial<InfraVulnerabilitiesTrendListRequest>): InfraVulnerabilitiesTrendListRequest {
        let obj = Object.assign(new InfraVulnerabilitiesTrendListRequest(), model);
        InfraVulnerabilitiesTrendListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InfraVulnerabilitiesTrendListRequest>): InfraVulnerabilitiesTrendListRequest {
        if (!model) return null;
        return InfraVulnerabilitiesTrendListRequest.newInstance(<InfraVulnerabilitiesTrendListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InfraVulnerabilitiesTrendListRequest) {
        if (!obj) return;

        models.InfraVulnerabilitiesTrendListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InfraVulnerabilitiesTrendListRequest): boolean {
        Object.setPrototypeOf(obj, InfraVulnerabilitiesTrendListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.InfraVulnerabilitiesTrendListRequestFilters.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.InfraVulnerabilitiesTrendListFiltersSortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.InfraVulnerabilitiesTrendListFiltersSortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.InfraVulnerabilitiesTrendListRequestFilters;

}
